module.exports = __webpack_public_path__ + "img/laboratorio4_4-3.7e65b951.webp";